/**
 * ═══════════════════════════════════════════════════════════════════════
 * Consiglieri — Modul de atribuire SITEWIDE (E5 §3.6, v1.1 / 2026-08-09)
 *
 * v1.1 (F6-3, GO Cristian): accept ÎNTÂRZIAT al consimțământului —
 *   la visitorConsentCollected cu marketing PERMIS, re-citim click-ID-urile
 *   (gclid/gbraid/wbraid/fbclid) din URL-ul curent și completăm touch-urile
 *   recente (fereastră 30 min). Înainte, listener-ul doar ȘTERGEA la revocare;
 *   un accept dat după încărcarea paginii pierdea definitiv click-ID-urile.
 *
 * Se încarcă pe TOATE paginile (snippet în theme.liquid, înaintea restului):
 *   {{ 'cs-attribution.js' | asset_url | script_tag }}
 * Fără dependențe. Consent-aware (Shopify Customer Privacy).
 *
 * Reguli (§3.6):
 *  · First-touch = IMUABIL (scris o singură dată, la primul semnal extern);
 *    TTL 90 zile.
 *  · Last-touch = ultimul touch NON-DIRECT (doar UTM / click-ID / referrer
 *    extern ≠ domeniile proprii); navigarea internă și vizitele directe NU
 *    suprascriu; TTL 30 zile.
 *  · previous_internal_url = câmp separat, session-scoped; la fiecare
 *    pageview se salvează ÎNTÂI prev = pagina_curentă_stocată, ABIA APOI se
 *    actualizează pagina curentă (formularul nu se listează pe sine).
 *  · Igienizare: landing/referrer fără query arbitrar — doar parametri
 *    whitelistați (utm_*; click-ID-urile doar cu consimțământ marketing);
 *    ≤512 caractere / câmp.
 *  · Stocare first-party: localStorage + fallback cookie; expus prin
 *    window.__csAttr (obiect — §3.3 face JSON.stringify(window.__csAttr)).
 *  · Consimțământ: click-ID-urile se SCRIU doar cu marketing permis; la
 *    revocare, click-ID-urile stocate se ȘTERG (listener
 *    visitorConsentCollected + loadFeatures fallback). UTM-urile (etichete
 *    de campanie, non-identificatori) se pot stoca oricând.
 *  · Per-domeniu (consiglierimen.com primește același snippet dacă rulează
 *    aceeași temă; fără sincronizare cross-domain în v1 — limită documentată).
 * ═══════════════════════════════════════════════════════════════════════
 */
(function () {
  if (window.__csAttrInstalled) return; window.__csAttrInstalled = true;

  var KEY = 'csAttr_v1';
  var COOKIE = 'cs_attr';
  var TTL_FIRST = 90 * 86400 * 1000;                 // 90 zile
  var TTL_LAST  = 30 * 86400 * 1000;                 // 30 zile
  var MAXF = 512;                                    // ≤512 caractere / câmp
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
  var OWN = ['consiglieri.ro', 'www.consiglieri.ro', 'consiglieri-ro.myshopify.com',
             'consiglierimen.com', 'www.consiglierimen.com'];

  function mktAllowed() {
    try {
      return !!(window.Shopify && Shopify.customerPrivacy &&
        Shopify.customerPrivacy.marketingAllowed &&
        Shopify.customerPrivacy.marketingAllowed() === true);
    } catch (_) { return false; }
  }
  function cap(s) { return String(s == null ? '' : s).slice(0, MAXF); }

  // ── Stocare: localStorage cu fallback cookie first-party ─────────────
  function load() {
    var raw = '';
    try { raw = localStorage.getItem(KEY) || ''; } catch (_) {}
    if (!raw) {
      try {
        var m = document.cookie.match('(^|;)\\s*' + COOKIE + '\\s*=\\s*([^;]+)');
        if (m) raw = decodeURIComponent(m.pop());
      } catch (_) {}
    }
    try { var o = JSON.parse(raw); return (o && typeof o === 'object') ? o : {}; }
    catch (_) { return {}; }
  }
  function save(store) {
    var raw = '';
    try { raw = JSON.stringify(store); } catch (_) { return; }
    var ok = false;
    try { localStorage.setItem(KEY, raw); ok = true; } catch (_) {}
    if (!ok) {
      try {
        document.cookie = COOKIE + '=' + encodeURIComponent(raw)
          + '; path=/; max-age=' + (90 * 86400) + '; SameSite=Lax; Secure';
      } catch (_) {}
    }
  }

  // ── Igienizare URL: origin+path + DOAR parametri whitelistați ────────
  function sanitizeUrl(href, allowIds) {
    try {
      var u = new URL(href);
      var out = u.origin + u.pathname;
      var keep = [];
      u.searchParams.forEach(function (val, key) {
        var k = key.toLowerCase();
        var whitelisted = k.indexOf('utm_') === 0 || (allowIds && IDS.indexOf(k) !== -1);
        if (whitelisted && val) keep.push(k + '=' + encodeURIComponent(val).slice(0, 160));
      });
      if (keep.length) out += '?' + keep.join('&');
      return cap(out);
    } catch (_) { return ''; }
  }
  function refHost(ref) {
    try { return ref ? new URL(ref).hostname.toLowerCase() : ''; } catch (_) { return ''; }
  }

  // ── Touch-ul curent (semnal extern?) ─────────────────────────────────
  function currentTouch() {
    var p;
    try { p = new URLSearchParams(location.search); } catch (_) { p = null; }
    var utm = {}, ids = {}, hasUtm = false, hasId = false;
    if (p) {
      UTM.forEach(function (k) { var v = p.get(k); if (v) { utm[k] = cap(v); hasUtm = true; } });
      IDS.forEach(function (k) { var v = p.get(k); if (v) { ids[k] = cap(v); hasId = true; } });
    }
    var rh = refHost(document.referrer);
    var external = !!rh && OWN.indexOf(rh) === -1;
    return {
      utm: utm, ids: ids,
      hasSignal: hasUtm || hasId || external,
      extRef: external ? sanitizeUrl(document.referrer, false) : ''
    };
  }

  // ── Pageview: expirări TTL → first/last → prev_internal_url ──────────
  function onPageview() {
    var now = Date.now();
    var store = load();
    var dirty = false;

    if (store.first && (now - (store.first.ts || 0) > TTL_FIRST)) { delete store.first; dirty = true; }
    if (store.last  && (now - (store.last.ts  || 0) > TTL_LAST))  { delete store.last;  dirty = true; }

    var t = currentTouch();
    var allowIds = mktAllowed();

    if (t.hasSignal) {
      var touch = { ts: now };
      UTM.forEach(function (k) { if (t.utm[k]) touch[k] = t.utm[k]; });
      if (allowIds) IDS.forEach(function (k) { if (t.ids[k]) touch[k] = t.ids[k]; });
      if (t.extRef) touch.ref = t.extRef;

      if (!store.first) {                              // IMUABIL: doar dacă lipsește
        store.first = touch;
        store.first.lp = sanitizeUrl(location.href, allowIds);   // landing inițial
        dirty = true;
      }
      store.last = touch;                              // ultimul touch NON-DIRECT
      dirty = true;
    }
    if (dirty) save(store);

    // previous_internal_url — session-scoped; ORDINEA contează (§3.6 v4.9):
    try {
      var cur = cap(location.origin + location.pathname);
      var stored = sessionStorage.getItem('csAttrCurPage') || '';
      if (stored && stored !== cur) sessionStorage.setItem('csAttrPrevPage', stored);
      sessionStorage.setItem('csAttrCurPage', cur);
    } catch (_) {}
  }

  // ── Revocare consimțământ → ștergem click-ID-urile stocate ───────────
  function stripIdsIfRevoked() {
    if (mktAllowed()) return;
    var store = load(), dirty = false;
    ['first', 'last'].forEach(function (part) {
      if (!store[part]) return;
      IDS.forEach(function (k) { if (store[part][k]) { delete store[part][k]; dirty = true; } });
      if (store[part].lp) {                            // scoate ID-urile și din landing
        var clean = sanitizeUrl(store[part].lp, false);
        if (clean && clean !== store[part].lp) { store[part].lp = clean; dirty = true; }
      }
    });
    if (dirty) save(store);
  }

  // ── Accept ÎNTÂRZIAT (v1.1) → re-citim click-ID-urile din URL-ul curent ──
  // Cazul reparat: utilizatorul aterizează cu ?gclid=... dar acceptă
  // marketingul ABIA DUPĂ pageview → onPageview() a stocat touch-ul FĂRĂ
  // click-ID-uri. La accept, completăm ID-urile lipsă în touch-urile RECENTE
  // (≤30 min — adică același touch, nu unul istoric). Dacă nu există niciun
  // touch (ex. blocked la landing), îl creăm acum din URL-ul curent.
  var RECENT_MS = 30 * 60 * 1000;
  function captureIdsIfAccepted() {
    if (!mktAllowed()) return;
    var t = currentTouch();
    var anyId = false;
    IDS.forEach(function (k) { if (t.ids[k]) anyId = true; });
    if (!anyId) return;
    var now = Date.now();
    var store = load(), dirty = false;

    if (!store.first && t.hasSignal) {
      var touch = { ts: now };
      UTM.forEach(function (k) { if (t.utm[k]) touch[k] = t.utm[k]; });
      IDS.forEach(function (k) { if (t.ids[k]) touch[k] = t.ids[k]; });
      if (t.extRef) touch.ref = t.extRef;
      touch.lp = sanitizeUrl(location.href, true);
      store.first = touch;
      store.last = store.last || touch;
      dirty = true;
    } else {
      ['first', 'last'].forEach(function (part) {
        var p = store[part];
        if (!p) return;
        if (now - (p.ts || 0) > RECENT_MS) return;     // doar touch-ul curent
        IDS.forEach(function (k) {
          if (t.ids[k] && !p[k]) { p[k] = t.ids[k]; dirty = true; }
        });
        if (p.lp) {                                    // completăm și landing-ul
          var bare = sanitizeUrl(p.lp, false);
          var full = sanitizeUrl(location.href, true);
          if (p.lp === bare && full && bare === sanitizeUrl(location.href, false)) {
            p.lp = full; dirty = true;
          }
        }
      });
    }
    if (dirty) save(store);
  }

  function onConsentCollected() {
    stripIdsIfRevoked();
    captureIdsIfAccepted();
  }
  try {
    document.addEventListener('visitorConsentCollected', onConsentCollected);
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) { if (!err) onConsentCollected(); });
    }
  } catch (_) {}

  // ── Expunere: window.__csAttr (obiect; §3.3 îl serializează) ─────────
  // Getter → snapshot LIVE la momentul submitului (aplică regulile de
  // consimțământ la citire, nu doar la scriere). Chei goale = omise.
  function snapshot() {
    var store = load();
    var allowIds = mktAllowed();
    var out = { v: 1 };
    function copy(prefix, part) {
      if (!part) return;
      if (part.ts) out[prefix + '_ts'] = part.ts;
      UTM.forEach(function (k) { if (part[k]) out[prefix + '_' + k] = part[k]; });
      if (allowIds) IDS.forEach(function (k) { if (part[k]) out[prefix + '_' + k] = part[k]; });
      if (part.ref) out[prefix + '_ref'] = part.ref;
      if (part.lp)  out[prefix + '_lp']  = allowIds ? part.lp : sanitizeUrl(part.lp, false);
    }
    copy('ft', store.first);
    copy('lt', store.last);
    try {
      var prev = sessionStorage.getItem('csAttrPrevPage');
      if (prev) out.prev_page = cap(prev);
    } catch (_) {}
    return out;
  }
  try {
    Object.defineProperty(window, '__csAttr', { get: snapshot, configurable: true });
  } catch (_) { window.__csAttr = snapshot(); }        // fallback static

  // Rulăm bookkeeping-ul de pageview imediat (scriptul e pe toate paginile).
  try { onPageview(); } catch (_) {}
})();
